<template>
  <div class="my-page">
    <div class="top-info" @click="toPersonalInfo">
      <img
        :src="userInfo.id && userInfo.photo ? userInfo.photo.url : defaultPhoto"
        alt=""
        class="user-photo"
      />
      <div class="top-left">
        <div class="dark-text">
          {{ userInfo.id ? userInfo.name : "未登录" }}
        </div>
        <div class="grey-text">
          {{ userInfo.id ? userInfo.phone : "点此登录" }}
        </div>
      </div>
      <span class="grey-text"><van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)"/></span>
    </div>
    <div class="info-wrapper">
      <div class="other-info">
        <template v-for="(sitem, sindex) in list" >
          <div
            class="info-item"
            v-if="sitem.isshow"
            :key="sitem.link"
            :class="{ 'van-hairline--bottom': sindex < list.length - 1 }"
            @click="toLinkUrl(sitem)"
          >
            <div class="item-left">
              <span class="item-icon">
                <svg class="vxm-icon" aria-hidden="true" font-size="24">
                  <use :xlink:href="sitem.icon"></use>
                </svg>
              </span>
              <span class="item-name">{{ sitem.name }}</span>
            </div>
            <div class="item-right"><van-icon name="arrow" size="var(--fs-ex1)" color="var(--g5)"/></div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    // let isWxxcx = app.base.env == "wxxcx";
    
    return {
      pageTitle: "我的",
      defaultPhoto: "https://cdn01.xiaogj.com/uploads/x3/assets/img/default/avt-00.png",
      list: [
        {
          icon: "#vxm-icon-qianbao",
          name: "电子钱包",
          link: "/e-wallet",
          isshow: true,
        },
        {
          icon: "#vxm-icon-dd",
          name: "订单管理",
          link: "/orderList",
          isshow: true,
        },
        {
          icon: "#vxm-icon-a-19",
          name: "会员积分",
          link: "/member",
          isshow: true,
        },
        {
          icon: "#vxm-icon-xueyuanxinxi",
          name: "学员信息",
          link: "/myStudents",
          isshow: true,
        },
      ]
    };
  },
  computed: {
    ...Vuex.mapState(["userInfo"]),
    memberOpened () {
      return this.userInfo.isOpenMember;
    },
  },
  methods: {
    toPersonalInfo() {
      if (!this.userInfo.id) {
        app.parent.login();
      } else {
        this.$router.push("/personalInfo");
      }
    },
    toLinkUrl(item) {
      if (!this.userInfo.id) {
        app.parent.login();
        return;
      }
      if (item.link === '/member') {
          this.showLoading();
          this.$api.findStudentInClass().then((res) => {
            this.$toast.clear();
            if (res.code == 200 && res.data) {
              if (res.data.length === 0) {
                this.$toast("暂无学员");
              } else if (res.data.length === 1){
                this.$router.push('/member?sId=' + res.data[0].studentId)
              } else {
                this.$router.push('/member-stu-chooser')
              }
            } else {
              this.$toast.fail(res.msg || "服务器出错，请稍后重试");
            }
          });
        return false;
      }
      if (item.link) {
        this.$router.push(item.link);
      }
    }
  },
  created () {
    const showOrder = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'ORDER_MANAGE' && item.openStatus == 1) : true;
    const showMember = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'MEMBER' && item.openStatus == 1) : true;
    const showWallet = this.userInfo.parentMenuOpenList ? this.userInfo.parentMenuOpenList.some(item=>item.menuCode === 'WALLET' && item.openStatus == 1) : true;
    this.list[2].isshow = this.memberOpened && showMember;
    this.list[1].isshow = showOrder;
    this.list[0].isshow = showWallet;
  }
};
</script>

<style lang="scss" scoped>
.my-page {
  padding: 0 calc(var(--gap) * 12) calc(var(--gap) * 12) calc(var(--gap) * 12);
  background: url("https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/003.png")
    no-repeat;
  background-size: contain;
  .grey-text {
    font-size: var(--fs-sm);
    color: var(--g6);
  }
  .top-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: calc(var(--gap) * 35) calc(var(--gap) * 12) calc(var(--gap) * 42) calc(var(--gap) * 12);
    height: calc(var(--w) * 128);
    position: relative;
    .top-left {
      height: calc(var(--w) * 56);
      flex: 1;
      padding-left: calc(var(--w) * 64);
      .dark-text {
        margin: calc(var(--gap) * 8) 0;
        font-size: var(--fs-ex1);
        font-weight: var(--bold);
      }
      // .item-tag {
      //   display: inline-block;
      //   font-size: var(--fs-sm);
      //   color: #1890ff;
      //   background-color: rgba(24, 144, 255, 0.15);
      //   height: 16px;
      //   line-height: 16px;
      //   padding: 0 4px;
      //   border-radius: 2px;
      //   margin-left: 8px;
      // }
    }
    .user-photo {
      position: absolute;
      left: calc(var(--gap) * 12);
      top: calc(var(--gap) * 36);
      height: calc(var(--w) * 56);
      width: calc(var(--w) * 56);
      border-radius: 50%;
      background: var(--g4);
    }
  }
  .info-wrapper {
    .other-info {
      background-color: var(--white);
      padding: 0 calc(var(--gap) * 12);
      margin-bottom: calc(var(--gap) * 12);
      font-size: var(--fs-lg);
      border-radius: var(--radius-sm);
      overflow: hidden;
      .info-item {
        height: calc(var(--w) * 54);
        line-height: calc(var(--w) * 54);
        display: flex;
        justify-content: space-between;
        .item-left {
          flex: 1;
          .item-icon {
            font-size: var(--fs-ex1);
            margin-right: calc(var(--gap) * 6);
          }
        }
        .item-right {
          flex: 1;
          text-align: right;
          color: var(--g6);
          .item-icon {
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>